<template>
    <div :id="id">
        <slot></slot>
    </div>
</template>

<script setup>
    const props = defineProps({
        errorMessage: { required: true, type: String },
        id: { default: () => nextId(), type: String }
    });

    let validator;

    const apply = (target) => {
        validator = target;
        validator.addRequiredGroup(`#${props.id}`, props.errorMessage);
    };

    const show = (message) => validator.showErrors({ [`#${props.id}`]: message });

    defineExpose({ apply, show });
</script>
